import React from 'react';
import { IBaseAction } from '@models/actions/IBaseAction';
import { DocBaseActionExecutor } from '@organisms/actions/DocBaseActionExecutor';
import ActionConfirmationModal from '@organisms/actions/ActionConfirmationModal/ActionConfirmationModal';
import { RouteNames } from '@/router/router.types';

export class RegisterOnBaseExecutor extends DocBaseActionExecutor {
    runInternal = (
        objId: string,
        parentId: string | undefined,
        action: IBaseAction,
        rowData?: any,
        completeHandler?: (isSucceed: boolean) => void,
    ) => {
        if (!action.options?.confirmation) {
            this.doAction(action, completeHandler, objId);
        }
    };

    private doAction(action: IBaseAction, completeHandler: ((isSucceed: boolean) => void) | undefined, objId: string) {
        if (this.navigate) {
            if (action.options?.newTab) {
                window.open(
                    RouteNames.DOCUMENT_CREATE_ON_BASE.replace(':baseDocId', objId)
                        .replace(':actId', action.key)
                        .replace('/:draftId', ''),
                    '_blank',
                    'noopener,noreferrer',
                );
            } else {
                if (window.location.href.indexOf('/document/createOnBase/') > -1) {
                    let st = this.location?.state as any;
                    if (st && st.fromPathname) {
                        this.navigate(
                            RouteNames.DOCUMENT_CREATE_ON_BASE.replace(':baseDocId', objId)
                                .replace(':actId', action.key)
                                .replace('/:draftId', ''),
                            {
                                state: {
                                    fromPathname: st.fromPathname,
                                    fromSearch: st.fromSearch,
                                    fromHash: st.fromHash,
                                },
                            },
                        );
                    } else {
                        this.navigate(
                            RouteNames.DOCUMENT_CREATE_ON_BASE.replace(':baseDocId', objId)
                                .replace(':actId', action.key)
                                .replace('/:draftId', ''),
                        );
                    }
                } else {
                    this.navigate(
                        RouteNames.DOCUMENT_CREATE_ON_BASE.replace(':baseDocId', objId)
                            .replace(':actId', action.key)
                            .replace('/:draftId', ''),
                        {
                            state: {
                                fromPathname: this.location?.pathname,
                                fromSearch: this.location?.search,
                                fromHash: this.location?.hash,
                            },
                        },
                    );
                }
            }
        } else {
            window.location.href = `.${RouteNames.DOCUMENT_CREATE_ON_BASE.replace(':baseDocId', objId).replace(':actId', action.key).replace('/:draftId', '')}`;
        }
        completeHandler && completeHandler(false);
    }

    visualElementInner = () => {
        return this._action?.options?.confirmation ? (
            <ActionConfirmationModal
                title={this._action.options.confirmation.title}
                message={this._action.options.confirmation.message}
                okButtonText={this._action.options.confirmation.okButtonText}
                cancelButtonText={this._action.options.confirmation.cancelButtonText}
                onOkClick={() => {
                    if (this._action && this._objId) {
                        this.doAction(this._action, this._completeHandler, this._objId);
                    }

                    return new Promise<void>((resolve, reject) => {
                        resolve();
                    });
                }}
                onCancelClick={() => {
                    this._completeHandler && this._completeHandler(false);
                }}
            />
        ) : (
            <></>
        );
    };
}
